import React, { useState } from 'react';
import { Tooltip, ClickAwayListener } from '@mui/material';

interface ClickableTooltipProps {
  title: string;
  children: React.ReactElement;
}

const ClickableTooltip: React.FC<ClickableTooltipProps> = ({ title, children }) => {
  const [open, setOpen] = useState(false);

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    setOpen(true);
  };

  return (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <div>
        <Tooltip
          PopperProps={{
            disablePortal: true,
          }}
          onClose={handleTooltipClose}
          open={open}
          disableFocusListener
          disableHoverListener
          disableTouchListener
          title={title}
          arrow
        >
          <span onClick={handleTooltipOpen} style={{ cursor: 'pointer' }}>
            {children}
          </span>
        </Tooltip>
      </div>
    </ClickAwayListener>
  );
};

export default ClickableTooltip; 